<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";

import { categories } from "./data-calendar";
import { mapActions, mapGetters, mapState } from "vuex";

/**
 * Contacts-Profile component
 */
export default {
  page: {
    title: "Profile",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, FullCalendar, ModelListSelect },
  data() {
    return {
      model_id: "",
      edit_appointment: {
        date: "",
        time: "",
        staff_id: "",
        id: "",
      },
      appointment_reminder: {
        send_to: "0",
        message: "",
        appointment_id: "",
      },
      title: "Appointment Details",
      items: [
        {
          text: "Client Section",
        },
        {
          text: "Appointments",
        },
        {
          text: "Details",
          active: true,
        },
      ],
      ///////////CALENDER DATA////////////////////////
      calendarOptions: {
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth",
        },
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        initialView: "dayGridMonth",
        themeSystem: "bootstrap",
        initialEvents: [],
        editable: true,
        droppable: true,
        eventResizableFromStart: true,
        dateClick: this.dateClicked,
        eventClick: this.editEvent,
        eventsSet: this.handleEvents,
        weekends: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
      },
      currentEvents: [],
      showModal: false,
      eventModal: false,
      categories: categories,
      submitted: false,
      submit: false,
      newEventData: {},
      edit: {},
      deleteId: {},
      event: {
        title: "",
        category: "",
      },
      editevent: {
        editTitle: "",
        editcategory: "",
      },
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("appointment", [
      "AppointmentDetails",
      "Appointment_status",
      "AppointmentCalendar",
      "AppoEditStatus",
    ]),
    ...mapGetters("staffModule", ["clinic_staff"]),
  },
  watch: {
    AppointmentCalendar(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        this.set_calendar();
      }
    },
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.submitted = false;
          this.$toast.success(this.notification_message.msg);
          this.closeMode(this.model_id);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchAppointmentDetails: "appointment/fetchAppointmentDetails",
      EditAppointMent: "appointment/editAppointment",
      FetchCalendarData: "appointment/fetchCalendarData",
      FetchStaff: "staffModule/fetchClinicStaff",
      ChangeAppointmentStatus: "appointment/changeAppointmentStatus",
      AppointmentReminder: "appointment/appointmentReminder",
    }),
    changeStatus(val, model) {
      this.model_id = model;

      let appointment = {
        new_status: val,
        id: this.AppointmentDetails.id,
      };
      this.ChangeAppointmentStatus(appointment);
    },
    sendSmsEminder() {
      this.model_id = "modal-reminder";
      this.appointment_reminder.appointment_id = this.AppointmentDetails.id;
      this.AppointmentReminder(this.appointment_reminder);
    },
    setEditApp() {
      this.model_id = "modal-editapp";
      this.edit_appointment = {
        date: this.AppointmentDetails.edate,
        time: this.AppointmentDetails.etime,
        staff_id: this.AppointmentDetails.doctor.id,
        id: this.AppointmentDetails.id,
      };
    },
    saveEdit() {
      this.EditAppointMent(this.edit_appointment);
    },
    set_calendar() {
      this.calendarOptions.initialEvents = this.AppointmentCalendar
        ? this.AppointmentCalendar
        : [];

      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 1000);
    },
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
  },

  created() {
    this.FetchAppointmentDetails(this.$route.params.id);
    this.FetchCalendarData(this.$route.params.id);
    this.set_calendar();
    this.FetchStaff();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="form-group">
      <button @click="$router.go(-1)" class="btn btn-success mb-2">
        <i class="fas fa-arrow-circle-left"></i> Go Back
      </button>
    </div>
    <div class="row">
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Client Information</h4>

            <br />
            <b-spinner
              v-if="Appointment_status"
              class="m-0"
              variant="primary"
              role="status"
            ></b-spinner>
            <div class="avatar-md profile-user-wid mb-2" v-else>
              <img
                src="@/assets/images/users/avatar-1.jpg"
                alt
                class="img-thumbnail rounded-circle"
              />
            </div>
            <div class="table-responsive">
              <table class="table table-nowrap mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Full Name :</th>
                    <td>
                      {{
                        AppointmentDetails.patient
                          ? AppointmentDetails.patient.patient_name
                          : "--"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Code :</th>
                    <td>
                      {{
                        AppointmentDetails.patient
                          ? AppointmentDetails.patient.patient_code
                          : "--"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Mobile :</th>
                    <td>
                      {{
                        AppointmentDetails.patient
                          ? AppointmentDetails.patient.patient_contact
                          : "--"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Email :</th>
                    <td>
                      {{
                        AppointmentDetails.patient
                          ? AppointmentDetails.patient.patient_email
                          : "--"
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- end card -->

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-5">Recent Appointments</h4>
            <div class>
              <ul
                class="verti-timeline list-unstyled"
                v-for="(appo, index) in AppointmentDetails.recent_appo
                  ? AppointmentDetails.recent_appo
                  : []"
                :key="index"
              >
                <li class="event-list active" v-if="appo.status_p == 0">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle bx-fade-right"></i>
                  </div>
                  <div class="media">
                    <div class="me-3">
                      <i class="bx bx-server h4 text-primary"></i>
                    </div>
                    <div class="media-body">
                      <div>
                        <h5 class="font-size-15">
                          <a href="javascript: void(0);" class="text-dark"
                            >With {{ appo.doctor.staff_name }}</a
                          >
                        </h5>
                        <span class="text-primary"
                          >{{ appo.date }}
                          <span class="badge bg-success">{{ appo.status }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="event-list" v-else>
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="media">
                    <div class="me-3">
                      <i class="bx bx-code h4 text-primary"></i>
                    </div>
                    <div class="media-body">
                      <div>
                        <h5 class="font-size-15">
                          <a href="javascript: void(0);" class="text-dark"
                            >With {{ appo.doctor.staff_name }}</a
                          >
                        </h5>
                        <span class="text-primary"
                          >{{ appo.date }}
                          <span :class="`badge bg-${appo.class}`">{{ appo.status }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
                <br />
              </ul>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>

      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Appointment Datils</h4>
            <div class="row">
              <div class="col-md-7">
                <div class="table-responsive">
                  <table class="table table-nowrap mb-0">
                    <tbody>
                      <tr>
                        <th scope="row">Appointment With:</th>
                        <td>
                          {{
                            AppointmentDetails.doctor
                              ? AppointmentDetails.doctor.staff_name
                              : "--"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Mobile :</th>
                        <td>
                          {{
                            AppointmentDetails.doctor
                              ? AppointmentDetails.doctor.staff_contact
                              : "--"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">E-mail :</th>
                        <td>
                          {{
                            AppointmentDetails.doctor
                              ? AppointmentDetails.doctor.staff_email
                              : "--"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Location :</th>
                        <td>
                          {{
                            AppointmentDetails.location
                              ? AppointmentDetails.location
                              : "--"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Time :</th>
                        <td>
                          {{ AppointmentDetails.date ? AppointmentDetails.date : "--" }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Added By :</th>
                        <td>
                          {{
                            AppointmentDetails.addedBy ? AppointmentDetails.addedBy : "--"
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-md-5">
                <div class="table-responsive">
                  <table class="table table-nowrap mb-0">
                    <tbody>
                      <tr>
                        <th scope="row">Status :</th>
                        <td>
                          {{
                            AppointmentDetails.status ? AppointmentDetails.status : "--"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Edit :</th>
                        <td>
                          <button
                            v-if="AppointmentDetails.rstatus == '0'"
                            v-b-modal.modal-editapp
                            class="btn btn-info btn-sm"
                            @click="setEditApp()"
                          >
                            Edit <i class="fa fa-edit"></i>
                          </button>
                          <button v-else disabled class="btn btn-primary btn-sm">
                            Edit
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Remind :</th>
                        <td>
                          <button
                            v-if="AppointmentDetails.rstatus == '0'"
                            v-b-modal.modal-reminder
                            class="btn btn-primary btn-sm"
                          >
                            Send Reminder <i class="fa fa-spinner"></i>
                          </button>
                          <button v-else disabled class="btn btn-primary btn-sm">
                            Send Reminder
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Done :</th>
                        <td>
                          <button
                            v-if="AppointmentDetails.rstatus == '0'"
                            v-b-modal.modal-markdone
                            class="btn btn-success btn-sm"
                          >
                            Mark Done <i class="fa fa-check"></i>
                          </button>
                          <button v-else disabled class="btn btn-success btn-sm">
                            Mark Done
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Cancel :</th>
                        <td>
                          <button
                            disabled
                            v-if="AppointmentDetails.rstatus == '1'"
                            class="btn btn-danger btn-sm"
                          >
                            Cancel <i class="fa fa-times"></i>
                          </button>
                          <button
                            v-else-if="AppointmentDetails.rstatus == '2'"
                            v-b-modal.modal-uncancel
                            class="btn btn-danger btn-sm"
                          >
                            Un Cancel <i class="fa fa-times"></i>
                          </button>
                          <button
                            v-else-if="AppointmentDetails.rstatus == '0'"
                            v-b-modal.modal-cancel
                            class="btn btn-danger btn-sm"
                          >
                            Cancel <i class="fa fa-times"></i>
                          </button>
                          <button v-else disabled class="btn btn-danger btn-sm">
                            Cancel
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              All
              <b class="text-info">{{
                AppointmentDetails.patient
                  ? AppointmentDetails.patient.patient_name
                  : "--"
              }}</b
              >'s Appointments on a Calendar
            </h4>

            <FullCalendar ref="fullCalendar" :options="calendarOptions"></FullCalendar>
          </div>
        </div>
      </div>

      <!-- SETART CANCELMODEL MODELA-->
      <div class="my-4 text-center">
        <b-modal
          id="modal-cancel"
          size="sm"
          title="Cancel Appointment"
          title-class="font-18"
          ok-title="Yes"
          cancel-title="No"
          hide-footer
        >
          <h4 class="text-danger">Are you sure you want to cancel this appointment?</h4>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary float-start"
              data-dismiss="modal"
              @click="$bvModal.hide('modal-editapp')"
            >
              No
            </button>
            <button
              @click="changeStatus(2, 'modal-cancel')"
              type="button"
              class="btn btn-danger"
            >
              Yes<b-spinner
                v-show="AppoEditStatus"
                style="float: right"
                class="m-0"
                small
                variant="light"
                role="status"
              ></b-spinner>
            </button>
          </div>
        </b-modal>
      </div>
      <!--END CANCELMODEL MODELA-->
      <!-- SETART UnCANCELMODEL MODELA-->
      <div class="my-4 text-center">
        <b-modal
          id="modal-uncancel"
          size="sm"
          title="Uncancel Appointment"
          title-class="font-18"
          ok-title="Yes"
          cancel-title="No"
          hide-footer
        >
          <h4 class="text-warning">
            Are you sure you want to uncancel this appointment?
          </h4>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary float-start"
              data-dismiss="modal"
              @click="$bvModal.hide('modal-uncancel')"
            >
              No
            </button>
            <button
              @click="changeStatus(0, 'modal-uncancel')"
              type="button"
              class="btn btn-warning"
            >
              Yes<b-spinner
                v-show="AppoEditStatus"
                style="float: right"
                class="m-0"
                small
                variant="light"
                role="status"
              ></b-spinner>
            </button>
          </div>
        </b-modal>
      </div>
      <!--END UNCANCELMODEL MODELA-->

      <!-- SETART Markdone MODELA-->
      <div class="my-4 text-center">
        <b-modal
          id="modal-markdone"
          size="sm"
          title="Mark Done Appointment"
          title-class="font-18"
          ok-title="Yes"
          cancel-title="No"
          hide-footer
        >
          <h4 class="text-success">Was this appointment done?</h4>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary float-start"
              data-dismiss="modal"
              @click="$bvModal.hide('modal-markdone')"
            >
              No
            </button>
            <button
              @click="changeStatus(1, 'modal-markdone')"
              type="button"
              class="btn btn-success"
            >
              Yes<b-spinner
                v-show="AppoEditStatus"
                style="float: right"
                class="m-0"
                small
                variant="light"
                role="status"
              ></b-spinner>
            </button>
          </div>
        </b-modal>
      </div>
      <!--END Markdone MODELA-->

      <!--REMIDER APPONTMENT MODEL-->
      <b-modal
        id="modal-reminder"
        title="SEND REMINDER SMS"
        title-class="font-18"
        hide-footer
      >
        <div class="alert alert-primary">Send a remider sms message for this appointment</div>
        <div class="form-group">
          <label>TO</label>
          <select class="form-control" v-model="appointment_reminder.send_to" >
            <option value="0">To Both Client and staff</option>
            <option value="1">To Only Client</option>
            <option value="2">To Only Staff</option>
          </select>
        </div>
        <div class="form-group"></div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary float-start"
            data-dismiss="modal"
            @click="$bvModal.hide('modal-reminder')"
          >
            Cancel
          </button>
          <button @click="sendSmsEminder()" type="button" class="btn btn-primary">
            Send     <b-spinner
              v-if="Appointment_status"
              class="m-0"
              variant="light"
              role="status"
              small
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!--REMIDER EDIT APPOINT MODEL-->

      <!--EDIT APPONTMENT MODEL-->
      <b-modal
        id="modal-editapp"
        title="EDIT APPOINTMENT"
        title-class="font-18"
        hide-footer
      >
        <div class="form-group">
          <label>DATE<span class="text-danger">*</span></label>
          <input type="date" class="form-control" v-model="edit_appointment.date" />
        </div>
        <div class="form-group">
          <label>TIME<span class="text-danger">*</span></label>
          <input v-model="edit_appointment.time" type="time" class="form-control" />
        </div>

        <div class="form-group">
          <label class="col-form-label">STAFF<span class="text-danger">*</span></label>
          <model-list-select
            :list="clinic_staff ? clinic_staff : []"
            v-model="edit_appointment.staff_id"
            option-value="id"
            option-text="staffName"
            placeholder="select staff"
          >
          </model-list-select>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary float-start"
            data-dismiss="modal"
            @click="$bvModal.hide('modal-editapp')"
          >
            Cancel
          </button>
          <button @click="saveEdit()" type="button" class="btn btn-success">
            Save Changes
            <b-spinner
              v-show="AppoEditStatus"
              style="float: right"
              class="m-0"
              small
              variant="light"
              role="status"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- EDIT APPOINT MODEL-->
    </div>
    <!-- end row -->
  </Layout>
</template>
